"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_SET_ELIGIBLE_PROGRAMS = 'USER_SET_ELIGIBLE_PROGRAMS';
exports.PROGRAMS_SET_PROGRAM_VIEWS = 'PROGRAMS_SET_PROGRAM_VIEWS';
exports.FETCHING_PROGRAM_VIEWS = 'FETCHING_PROGRAM_VIEWS';
exports.PROGRAM_VIEWS_SET_LAST_FETCHED = 'PROGRAM_VIEWS_SET_LAST_FETCHED';
exports.fetchingProgramView = function (programViewId) { return "FETCHING_PROGRAM_VIEW_" + programViewId; };
//# sourceMappingURL=action-types.js.map